import { render, staticRenderFns } from "./fixed-table.vue?vue&type=template&id=2f4567cc"
import script from "./fixed-table.vue?vue&type=script&lang=js"
export * from "./fixed-table.vue?vue&type=script&lang=js"
import style0 from "./fixed-table.vue?vue&type=style&index=0&id=2f4567cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../asogrow/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports